import connectSite from './connect-site';
import copyPage from './copy-page';
import createPage from './create-page';
import createPageFromTemplate from './create-page-from-template';
import deletePage from './delete-page';
import setActivePage from './set-active-page';
import changePagesOrder from './change-pages-order';
import setPagesInNavigation from './set-pages-in-navigation';
import setHomePage from './set-home-page';
import setHtmlCheckpoint from './set-html-checkpoint';
import setPageHTML from './set-page-html';
import setPageUsedBlocks from './set-page-used-block';
import setSession from './set-session';
import setSettings from './set-settings';
import setSiteId from './set-site-id';
import setSiteName from './set-site-name';
import setSiteProperties from './set-site-properties';
import setSiteProperty from './set-site-property';
import updateSettings from './update-settings';
import updatePageSettings from './update-page-settings';
import setOwnerId from './set-owner-id';
import setMultilingual from './set-multilingual';
import setPages from './set-pages';
import translatePage from './translate-page';
import setUpdatedAt from './set-updated-at';
import addUsedCustomColor from './add-used-custom-color';
import deleteUsedCustomColor from './delete-used-custom-color';
import setLastAppliedMigrationId from './set-last-applied-migration-id';
import setCleanUrlsEnabled from './set-clean-urls-enabled';
import exportSite from './export-site';
import setRedirects from './set-redirects';
import updateRedirects from './update-redirects';
import initSettingsForFirstLoading from './init-settings-for-first-loading';
import setIntegrations from './set-integrations';
import updateIntegrations from './update-integrations';
import reloadSiteMeta from './reload-site-meta';

export default {
  connectSite,
  copyPage,
  createPage,
  createPageFromTemplate,
  deletePage,
  setActivePage,
  changePagesOrder,
  setPagesInNavigation,
  setHomePage,
  setHtmlCheckpoint,
  setOwnerId,
  setPageHTML,
  setPageUsedBlocks,
  setSession,
  setSettings,
  setSiteId,
  setSiteName,
  setSiteProperties,
  setSiteProperty,
  updateSettings,
  updatePageSettings,
  setMultilingual,
  setPages,
  translatePage,
  setUpdatedAt,
  setLastAppliedMigrationId,
  addUsedCustomColor,
  deleteUsedCustomColor,
  setCleanUrlsEnabled,
  exportSite,
  setRedirects,
  updateRedirects,
  initSettingsForFirstLoading,
  setIntegrations,
  updateIntegrations,
  reloadSiteMeta,
};
